import type { SpriteDefinition } from '@/render/spriteBaker';
import { PALETTE } from '@/sprites/palette';

/**
 * Traps, armed and sprung.
 *
 * They are meant to be *seen* — the whole design is that a corridor becomes a
 * choice rather than a lottery — so both states read at a glance: teeth up and
 * pale, or flat and dark.
 */

const SPIKES_ARMED: string[] = [
  '................',
  '................',
  '..R..R..R..R....',
  '.RRR.RRR.RRR....',
  '.RwR.RwR.RwR....',
  '.RRR.RRR.RRR....',
  '................',
  '..R..R..R..R....',
  '.RRR.RRR.RRR....',
  '.RwR.RwR.RwR....',
  '.RRR.RRR.RRR....',
  '................',
  '..R..R..R..R....',
  '.RRR.RRR.RRR....',
  '.RwR.RwR.RwR....',
  '.RRR.RRR.RRR....',
];

const SPIKES_SPRUNG: string[] = [
  '................',
  '................',
  '................',
  '.eee.eee.eee....',
  '.eee.eee.eee....',
  '................',
  '................',
  '................',
  '.eee.eee.eee....',
  '.eee.eee.eee....',
  '................',
  '................',
  '................',
  '.eee.eee.eee....',
  '.eee.eee.eee....',
  '................',
];

const DARTS_ARMED: string[] = [
  '................',
  '.RRRRRRRRRRRRRR.',
  '.ReeReeReeReeeR.',
  '.RewRewRewReeeR.',
  '.ReeReeReeReeeR.',
  '.RRRRRRRRRRRRRR.',
  '................',
  '................',
  '................',
  '................',
  '.RRRRRRRRRRRRRR.',
  '.ReeReeReeReeeR.',
  '.RewRewRewReeeR.',
  '.ReeReeReeReeeR.',
  '.RRRRRRRRRRRRRR.',
  '................',
];

const DARTS_SPRUNG: string[] = [
  '................',
  '.RRRRRRRRRRRRRR.',
  '.ReeeeeeeeeeeeR.',
  '.ReeeeeeeeeeeeR.',
  '.ReeeeeeeeeeeeR.',
  '.RRRRRRRRRRRRRR.',
  '................',
  '................',
  '................',
  '................',
  '.RRRRRRRRRRRRRR.',
  '.ReeeeeeeeeeeeR.',
  '.ReeeeeeeeeeeeR.',
  '.ReeeeeeeeeeeeR.',
  '.RRRRRRRRRRRRRR.',
  '................',
];

export const TRAP_SPRITES = {
  'spikes-armed': { name: 'trap-spikes-armed', rows: SPIKES_ARMED, palette: PALETTE },
  'spikes-sprung': { name: 'trap-spikes-sprung', rows: SPIKES_SPRUNG, palette: PALETTE },
  'darts-armed': { name: 'trap-darts-armed', rows: DARTS_ARMED, palette: PALETTE },
  'darts-sprung': { name: 'trap-darts-sprung', rows: DARTS_SPRUNG, palette: PALETTE },
} as const satisfies Record<string, SpriteDefinition>;

export type TrapSpriteKey = keyof typeof TRAP_SPRITES;
